import React, { useState } from "react";
import { Container, Snackbar, Alert, TextField, Card, Button, Typography, Grid, CardActions, FormControl, Select, MenuItem, LinearProgress } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux'
import { setRegister } from 'api/auth';
import { useOrgQListQuery } from 'services/org'
import { useRoleListQuery } from 'services/role';
import { useUserCreateMutation, useUserCognitoMutation, useSmListQuery, useStripeUserCreateMutation } from 'services/user';
import { v4 as uuidv4 } from 'uuid'

const UserCreate = (props) => {
    const navi = useNavigate();
    const dispatch = useDispatch();
    const register = useSelector(state => state.auth.register);

    const [disableButton, setDisableButton] = useState(false);
    const [sb, setSB] = useState({ open: false, message: '', duration: 3000 });

    const [userCreateMutation, { isLoading: isUpdating }] = useUserCreateMutation();
    const [userStripeCreateMutation, { isLoading: issUpdating }] = useStripeUserCreateMutation();
    const [userCognitoMutation, { isLoading: isCognitoUpdating }] = useUserCognitoMutation();

    const handleCancel = () => {
        navi("/users/list")
    }

    const q = {
        "query": {
            "bool": {
                "must": [
                    {
                        "match": { status: true }
                    }
                ]
            }
        },
        "size": 100
    }



    const { orgList } = useOrgQListQuery({ q: q },
        {
            selectFromResult: ({ data }) => ({
                orgList: data?.hits?.hits?.map(s => s._source) || [],
            })
        }
    );

    const { roleList } = useRoleListQuery({},
        {
            selectFromResult: ({ data }) => ({
                roleList: data?.hits?.hits?.map(s => s._source) || [],
            })
        }
    );

    const { smList } = useSmListQuery({ orgId: register.orgId },
        {
            skip: !register.orgId,
            selectFromResult: ({ data }) => ({
                smList: data?.map(s => s._source) || [],
            })
        }
    );

    const handleClose = () => {
        setSB({ ...sb, open: false });
    };

    const onPhoneChange = (value) => {
        if (value.length < 11) {
            dispatch(setRegister({ phone: value }))
            dispatch(setRegister({ phone_number: `+1${register.phone}` }))
        }

    }

    const createUser = (record) => {
        userCreateMutation(record)
            .unwrap()
            .then(result => {
                console.log('Result from Elastic', result);
                setTimeout(() => {
                    setDisableButton(false);
                    navi("/users/list");
                }, 5000)
            })
            .catch(err => {
                setSB({ ...sb, open: true, message: err.message });
                setDisableButton(false);
            })
    }

    const onSave = () => {
        setDisableButton(true);
        userCognitoMutation(register)
            .unwrap()
            .then(result => {
                console.log('Result from Cognito', result);
                var id = result.User.Username;
                var record = {
                    ...register,
                    id: id
                }

                if (record.role === 'acc') {

                    var sCustomer = {
                        email: record.username,
                        name: `${record.firstName} ${record.lastName}`,
                        phone: record.phone_number,
                    }

                    userStripeCreateMutation(sCustomer)
                        .unwrap()
                        .then(stripeUser => {
                            console.log('Result from Stripe', stripeUser);
                            record = {
                                ...record,
                                stripeCustomerId: stripeUser.id
                            }
                            createUser(record);
                        })
                        .catch(err => {
                            setDisableButton(false);
                        })

                } else {
                    createUser(record);
                }
            })
            .catch(err => {
                setSB({ ...sb, open: true, message: err.message });
                setDisableButton(false);
            })
    }

    return (
        <React.Fragment>
            <CommonListHeader value={{ title: "Create New User", description: "Add new User" }} />

            <Container maxWidth={'md'}>
                <Card>
                    {disableButton ? <LinearProgress /> : ''}
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">First Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                onChange={(event) => dispatch(setRegister({ firstName: event.target.value }))}
                                value={register.firstName || ''}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Last Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                onChange={(event) => dispatch(setRegister({ lastName: event.target.value }))}
                                value={register.lastName || ''}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Role</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <FormControl fullWidth>

                                <Select
                                    value={register?.role || ''}
                                    onChange={(event) => dispatch(setRegister({ role: event.target.value }))}
                                >
                                    {roleList?.map((o, i) =>
                                        <MenuItem key={i} value={o.code}>{`${o.name}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {register.role !== 'sa' ? <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <FormControl fullWidth>

                                <Select
                                    value={register?.orgId || ''}
                                    onChange={(event) => dispatch(setRegister({ orgId: event.target.value }))}
                                >
                                    {orgList?.map((o, i) =>
                                        <MenuItem key={i} value={o.id}>{`${o.name}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid> : ''}

                    {register.role === 'adv' ? <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Service Manager</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <FormControl fullWidth>

                                <Select
                                    value={register?.smId || ''}
                                    onChange={(event) => dispatch(setRegister({ smId: event.target.value }))}
                                >
                                    {smList?.map((o, i) =>
                                        <MenuItem key={i} value={o.id}>{`${o.firstName} ${o.lastName}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid> : ''}

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">E-Mail / UserName</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                onChange={(event) => dispatch(setRegister({ username: event.target.value }))}
                                value={register.username || ''}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Phone</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField
                                variant="outlined"
                                type="number"
                                fullWidth
                                onChange={(event) => onPhoneChange(event.target.value)}
                                value={register.phone || ''}
                            />
                        </Grid>
                    </Grid>

                    <CardActions sx={{ padding: "15px" }}>
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            color='primary'
                            type="submit"
                            onClick={() => onSave()}
                        >
                            Submit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                    </CardActions>
                </Card>
            </Container>
            <Snackbar
                color='error'
                open={sb.open}
                autoHideDuration={sb.duration}
                onClose={handleClose}
                message={sb.message}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleClose}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {sb.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    )


}

export default UserCreate;